<template>
    <div>
        <div class="container relative z-10 max-w-3xl mx-auto md:mb-12">
            <div class="pt-8 text-center lg:pt-24">
                <h1 class="max-w-lg mx-auto mb-6 text-4xl font-semibold leading-tight tracking-tight font-noto-sans lg:text-6xl text-grey-darkest">
                    Property blog
                </h1>

                <h2 class="max-w-md mx-auto text-xl lg:text-2xl">
                    Latest property news, and updates from the Rentora team.
                </h2>
            </div>
        </div>

        <svg
            class="w-full h-10 text-blue-bg"
            preserveAspectRatio="none"
            viewBox="0 0 375 40"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path d="M375 40V0s-87.046 32-187.5 32S0 0 0 0v40h375z" />
        </svg>

        <div class="bg-blue-bg">
            <div class="container max-w-3xl pt-6 mx-auto md:pt-12">
                <blog-posts-get
                    :preloaded="preloaded('posts')"
                    :get-on-created="!preloaded('posts')"
                >
                    <div
                        slot-scope="{
                            data: posts,
                            error,
                            is_loading,
                            has_loaded,
                            get
                        }"
                    >
                        <template v-if="!has_loaded || error">
                            <base-loading
                                :error="error"
                                :retry="get"
                                class="py-6"
                            />

                            <error-modal
                                v-if="error"
                                :error="error"
                            />
                        </template>

                        <template v-else>
                            <grid-layout>
                                <grid-layout-item
                                    v-for="post in posts"
                                    :key="post.uuid"
                                    class="mb-12 md:mb-24 sm:w-1/2 lg:w-1/3"
                                >
                                    <router-link
                                        :to="{
                                            name: 'www.blog.show',
                                            params: {
                                                post: post.slug
                                            }
                                        }"
                                        class="block w-full h-full bg-white border rounded hover:shadow-lg"
                                    >
                                        <div
                                            class="bg-cover rounded-t aspect-ratio-16/9"
                                            :style="`background-image: url(${post.featured_image})`"
                                        />

                                        <div class="p-6">
                                            <h2 class="inline-flex items-center mb-3 text-lg text-blue">
                                                {{ post.title }}

                                                <base-svg
                                                    name="icon-cheveron-right"
                                                    class="w-6 h-6 fill-primary-blue"
                                                />
                                            </h2>

                                            <p class="text-grey-darker">
                                                {{ post.excerpt | limit(100) }}
                                            </p>
                                        </div>
                                    </router-link>
                                </grid-layout-item>
                            </grid-layout>
                        </template>
                    </div>
                </blog-posts-get>
            </div>
        </div>
    </div>
</template>

<script>
    import HeadMixin from '../../../mixins/head'
    import PreloadedMixin from '../../../mixins/preloaded'
    import BlogPostsGet from '../../../components/blog-posts-get'

    export default {
        mixins: [
            HeadMixin,
            PreloadedMixin
        ],
        components: {
            BlogPostsGet
        },
        methods: {
            head () {
                return {
                    title: [
                        'Property news',
                        'Property blog'
                    ]
                }
            }
        }
    }
</script>
